var _rect, _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 31,
    height: 31,
    rx: 10,
    stroke: "url(#paint0_linear_102_5)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.5C25 20.9837 21.9752 24 18 24C14.0248 24 11 20.9837 11 17.5C11 14.0163 14.0248 11 18 11C21.9752 11 25 14.0163 25 17.5Z",
    stroke: "url(#paint1_linear_102_5)",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 9,
    r: 2,
    fill: "#C92E93"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_5",
    x1: 26,
    y1: 8.5,
    x2: -2.00001,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32205,
    stopColor: "#E02C71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498081,
    stopColor: "#EF4E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708483,
    stopColor: "#F66834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855594,
    stopColor: "#FDB95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_5",
    x1: 29,
    y1: 4.5,
    x2: 5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233291,
    stopColor: "#C331A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611993,
    stopColor: "#E7385F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68C35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.ad463550415bbdb5a55aab8f185ef438.svg";
export { ForwardRef as ReactComponent };